/* Mouvement Chanoyu. Aucune librairie. Respecte prefers-reduced-motion. */
(function () {
  var doux = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --- révélation au défilement ----------------------------------------- */
  function preparerRevelations() {
    if (doux.matches || !('IntersectionObserver' in window)) return;
    var sections = Array.prototype.slice.call(document.querySelectorAll('main .shopify-section'));
    sections.forEach(function (s, i) {
      // le premier écran est visible d'emblée : on ne l'anime jamais.
      // sur une fiche produit le fil d'Ariane compte comme section, d'où les deux premières.
      if (i < 2) return;
      // l'information d'achat ne doit jamais dépendre d'une animation
      if (s.querySelector('.section-fiche__achat, .section-hero__texte')) return;
      var cibles = s.querySelectorAll(
        '.section-grille__entete, .section-grille__cartes > *, .section-famille__entete,' +
        '.section-famille__grille > *, .section-col-grille__cartes > *, .section-preuve__item,' +
        '.section-maison__photo, .section-maison__texte, .section-interlude__citation,' +
        '.section-diagnostic__texte, .section-diagnostic__carte, .section-newsletter__interieur,' +
        '.section-credibilite__piste, .section-col-entete__titre, .section-col-entete__chapo,' +
        '.section-desc__gauche, .section-desc__droite, .section-sens__axe, .section-donnees__groupe,' +
        '.section-origine__grille > *, .section-complements__grille > *, .section-engagement__item,' +
        '.section-questions__item, .section-adequation__axe-col, .section-adequation__carte'
      );
      // pas de repli sur la section entière : un bloc qu'on ne sait pas cibler
      // reste simplement visible, plutôt que de risquer de ne jamais apparaître
      if (!cibles.length) return;
      var liste = cibles;
      Array.prototype.forEach.call(liste, function (el, j) {
        el.setAttribute('data-reveal', '');
        el.style.setProperty('--delai', Math.min(j * 60, 300) + 'ms');
      });
    });

    var observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('est-visible');
        observateur.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    document.querySelectorAll('[data-reveal]').forEach(function (el) { observateur.observe(el); });
  }

  /* --- en-tête collant --------------------------------------------------- */
  function preparerEntete() {
    var entete = document.querySelector('.section-entete');
    if (!entete) return;
    var dernier = 0, enAttente = false;
    function majuscule() {
      entete.classList.toggle('est-decolle', window.scrollY > 8);
      enAttente = false;
    }
    window.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(majuscule);
    }, { passive: true });
    majuscule();
    void dernier;
  }

  function demarrer() { preparerRevelations(); preparerEntete(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  // l'éditeur de thème recharge des sections : on rejoue
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('est-visible'); });
  });
})();
